import { useContext, useState, useRef, useEffect, useMemo } from "react";
import Head from "next/head";
import Page from "../layouts/main";
import Context from "../components/context/context";
import CTA from "../components/CTA/cta.module";
import Footer from "../components/Footer/footer.module";
import InlineQuestion from "../components/InlineQuestion/inline-question.module";
import styles from "../styles/modules/faq.module.scss";
import { FAQs as data } from "../util/data";
import { DEFAULT_LOCATION } from "../util/locations";

const FAQ = () => {
  const page = useRef();
  const [analytics, setAnalytics] = useState();

  const { location } = useContext(Context);
  const locationToUse = useMemo(() => location ? location : DEFAULT_LOCATION, [location]);

  useEffect(() => {
    if (page.current) {
      setAnalytics(page.current.analytics);
    }
  }, []);

  return (
    <Page id={styles["page-faq"]} ref={page}>
      <Head>
        <title>FAQ - Kudos Golf</title>
      </Head>
      <section className={`section-content ${styles["section-faq"]}`}>
        <h2 className={styles.header}>Frequently Asked Questions</h2>

        <div className={styles["faqs-container"]}>
          {data.map((category, idx) => (
            <section className={styles["faqs-category"]} key={idx}>
              <h4 className={styles["faqs-category-title"]}>
                {category.category}
              </h4>

              {category.questions.map((question, index) => (
                <InlineQuestion
                  email={locationToUse.email}
                  question={question.question}
                  answer={question.answer}
                  defaultExpanded={idx === 0 && index === 0}
                  key={index}
                />
              ))}
            </section>
          ))}
        </div>

        <p className="text-body-medium">
          For all other questions and inquiries, please contact us at&nbsp;
          <CTA
            href={`mailto:${locationToUse.email}`}
            className={"text-link"}
            text={locationToUse.email}
            analytics={analytics}
            src="/faq"
            dest={locationToUse.email}
          />
        </p>
      </section>

      <Footer />
    </Page>
  );
};

export default FAQ;
